import AlertType from "./AlertType";

// Hack. TODO: move it. i18n
const AlertTypeDescriptions = {
	[AlertType.NONE]: "No Alerts",
	[AlertType.O7D]: "No AIS update (7 days+)",
	[AlertType.O1D]: "No AIS update (24 hours+)",
	[AlertType.O2D]: "No AIS update (48 hours+)",
	[AlertType.O22H]: "No AIS update (22 hours+)",
	[AlertType.ABO]: "AIS back on",
	[AlertType.ERI]: "Entered region of interest",
	[AlertType.CAS]: "Static changes at sea",
	[AlertType.LRI]: "Left region of interest",
	[AlertType.PCS]: "Entered Port",
	[AlertType.LPO]: "Left Port",
	[AlertType.ETW]: "Entered Territorial Waters",
	[AlertType.LTW]: "Left Territorial Waters",
	[AlertType.EEZ]: "Entered Exclusive Economic Zone",
	[AlertType.LEZ]: "Left Exclusive Economic Zone",
	[AlertType.MYF]: "My Fleet",
	[AlertType.STS]: "Ship-to-ship Transfer",
	[AlertType.NBY]: "Nearby Vessels",
	[AlertType.RIM]: "Risk Management",
	[AlertType.DEC]: "Destination Change",
	[AlertType.COF]: "Competitor's Fleet",
	EAS: "Entered Airspace"
};
export default AlertTypeDescriptions;
